export default "__VITE_ASSET__0af2dbbc__"